import { setDeliveryActionSuccess } from './actionCreators'

const setDeliveryModeActionRequest = (data) => (dispatch) => {
  localStorage.setItem('merchantOrderMode', JSON.stringify(data))
  dispatch(setDeliveryActionSuccess(data))
}

export default setDeliveryModeActionRequest
